<template>
  <!-- 选择学习班  -->
  <div class="schedulingStartPanlOne">
    <el-row>
      <div class="form_box__group__item">
        <div class="form_box__group__item__title ml-5">类型：</div>
        <div class="form_box__group__item__content">
          <el-radio-group v-model="type">
            <el-radio :label="item.id" v-for="item in typeOptions" :key="item.id">{{item.title}}</el-radio>
          </el-radio-group>
        </div>        
      </div>
    </el-row>
    <el-row v-show="type == 1">
      <div class="form_box__group__item">
        <!-- <div class="form_box__group__item__title ml-5">所属学习班</div> -->
        <div class="form_box__group__item__content">
            <selectStudyclass 
              @onDataChanged="onStudyClassChanged" 
              ref="selectStudyclass" 
              class="ml-5"></selectStudyclass>
        </div>        
      </div>
    </el-row>

    <template v-if="isEdit">
      <div class="schedulingstart__tool switch_operation mt-5 ml-5">
        <el-button type="primary" @click="onUpdate">更新</el-button>
      </div>
    </template>
    <template v-else>
      <div class="schedulingstart__tool switch_operation mt-5">
        <el-button type="primary" @click="onClickNext">下一步</el-button>
      </div>
    </template>



  </div>
</template>




<script>

import selectStudyclass from "@/views/module/course/comp/selectStudyclass.vue";
import { schedulingEditInitApi,schedulingEditTypeApi } from "@/api/module/scheduling/scheduling"

export default {
  name: "SchedulingTypePanel",
  components: {
    selectStudyclass
  },
  data() {
    return {

      // update scope
      id : null, 
      loading: false, 
      // update



      studyClassId : "",
      studyClassVal : "",
      studyClassType : "",
      type : 0,

      //store
      isAdmin : 0,
      roleid : null,
      roleinfos : null,

      formdata : {
        type :  0,    // 选择类型：0 默认 、1 学习班 、 2 单位课程  、 3 党组织生活
        scid : 0 , // studyclass.id
        scname : "" // studyclass.name
      }
    };
  },
  methods:{
    init(){

      let id = this.$route.query.id;
      if(id){
        this.id = id;
        schedulingEditInitApi(id)
          .then((r)=>{
            console.log("schedulingEditInitApi",r);

            this.studyClassId = r.sid;

            if(r.type == 1){
              this.type = 3
            }
            else {
              this.type = 1;
            }

            this.$refs.selectStudyclass.initData(r.sid)

          })

      }

      else {
        if(this.isAdmin || this.isSystemManager){
          this.type = 2;
        }
        else {
          this.type = 0;
        }
      }
    },

    onStudyClassChanged(e){
      console.log("onStudyClassChanged",e)
      this.studyClassId = e.id
      this.studyClassVal = e.title
    },


    onClickNext(){

      this.formdata.type = this.type;

      if(this.type == 1){
        this.formdata.scid = this.studyClassId;
        this.formdata.scname = this.studyClassVal;
      }
      else {
        this.formdata.scid = null;
        this.formdata.scname = null;
      }

      console.log("onClickNext",this.formdata)

      //  studyclass.id ,  studyClassVal 文本
      this.$emit('onClickNext',this.formdata)
    },

    onUpdate(){
      this.loading = true;


      this.$message.info("更新中")

      schedulingEditTypeApi(this.id,this.type,this.studyClassId)
        .then((r)=>{

          this.$message.success("更新成功")
          this.init();
        })
        .finally(()=>{
          this.loading = false;
        })


    }
    
  },
  computed: {
    typeOptions(){
      let options = [];
      if(this.isAdmin || this.isSystemManager){
        options = [
          {
            "id": 1,
            "title":"选择学习班"
          },
          {
            "id": 2,
            "title":"默认（单位课程）"
          },
          {
            "id": 3,
            "title":"默认（党组织生活）"
          },
        ]
      
      }
      else {
       options = [
          {
            "id": 0,
            "title":"默认"
          },
          {
            "id": 1,
            "title":"选择学习班"
          }
        ]
      }
      return options;
    },


    // store
    isSystemManager(){
      return this.roleid == "00001";
    },

    isUnitManager(){
        return this.roleid == "00003";
    },

    isPartyManager(){
        return this.roleid == "00002";
    },

    isEdit(){
      return this.id != null;
    }

  },
  watch:{
    location(oldVal,newVal){

    }
  },
  mounted(){
    this.isAdmin = this.$store.getters['profileModule/isadmin'];
    this.roleid = this.$store.getters['profileModule/roleid'];
    this.roleinfos = this.$store.getters['profileModule/roleinfos'];
    this.init();
  },
  created() {

  }
};
</script>

<style scoped lang="scss">
::v-deep .el-input--suffix .el-input__inner{
  width: 260px;
}

.switch_operation {
  padding: 20px 5px 20px;
}

</style>